import React from 'react';
import './Common/Layout.css';
import { useStitchAuth } from './StitchAuth';
import MemberList from './MemberList/MemberList';
import Login from './Login';

export default function Home() {
  const { isLoggedIn } = useStitchAuth();

  if (isLoggedIn) {
    return <MemberList />;
  } else {
    return <Login />;
  }
}
